import BrevetExamsList from "../../lists/brevetScreen/BrevetExamsList";

export default function BrevetExamsContent() {
    // Used in BrevetScreen to display core content

    return (
        <div className={"animate-appearSlow grow w-full flex flex-col justify-start min-h-0 px-[16px]"}>
            <BrevetExamsList />
        </div>
    );
}